import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import Placeholder from 'components/consumer/Placeholder';
import classNames from 'classnames';
import PDPNameSectionPlaceholder from './PDPNameSection/PDPNameSectionPlaceholder';
import PDPShopTabsBarPlaceholder from './PDPShopTabsBar/PDPShopTabsBarPlaceholder';
import PDPChooseYourOptionsPlaceholder from './PDPChooseYourOptions/PDPChooseYourOptionsPlaceholder';
import PDPProtectionPlanSelectorPlaceholder from './PDPProtectionPlanSelector/PDPProtectionPlanSelectorPlaceholder';
import PDPAddToBagSectionPlaceholder from './PDPAddToBagSection/PDPAddToBagSectionPlaceholder';
import useIsLayoutRevampVariant from './useIsLayoutRevampVariant';

/**
 * Hero-promise Suspense fallback: large image rect + minimal chrome.
 * Intentionally lighter than full-page PDPPlaceholder.
 */
const PDPHeroShellPlaceholder = t0 => {
  const $ = _c(25);
  const {
    className: parentClassName,
    isEditOrder: t1,
    pdpIsModularBYOProduct: t2
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const pdpIsModularBYOProduct = t2 === undefined ? false : t2;
  const isLayoutRevamp = useIsLayoutRevampVariant() && !pdpIsModularBYOProduct && !isEditOrder;
  let t3;
  if ($[0] !== parentClassName) {
    t3 = classNames("hidden lg:flex mx-auto my-0 py-0 flex-row-reverse !pt-2 !pb-8 px-5 md:px-[3.333vw] min-[1500px]:px-[50px] max-w-[1800px]", parentClassName);
    $[0] = parentClassName;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <PDPNameSectionPlaceholder />;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== isLayoutRevamp) {
    t5 = <PDPShopTabsBarPlaceholder isLayoutRevamp={isLayoutRevamp} />;
    $[3] = isLayoutRevamp;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  let t7;
  let t8;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <PDPChooseYourOptionsPlaceholder />;
    t7 = <PDPProtectionPlanSelectorPlaceholder />;
    t8 = <PDPAddToBagSectionPlaceholder />;
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
  } else {
    t6 = $[5];
    t7 = $[6];
    t8 = $[7];
  }
  let t9;
  if ($[8] !== t5) {
    t9 = <div className="flex-none min-w-[460px] w-[460px] [@media(width:1024px)]:min-w-[400px] [@media(width:1024px)]:w-[400px]">{t4}{t5}{t6}{t7}{t8}</div>;
    $[8] = t5;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      maxWidth: "calc((100vh - 194px) / 0.6666666666666666)"
    };
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="flex-1 mr-12"><div className="sticky top-8"><div className="mb-8 flex flex-col items-center relative" style={t10}><Placeholder loading={true} type="rect" style={{
            width: "50vw",
            height: "70vh",
            margin: "none"
          }} /></div></div></div>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== t3 || $[13] !== t9) {
    t12 = <div className={t3} data-xc="PDPHeroShellPlaceholder-desktop">{t9}{t11}</div>;
    $[12] = t3;
    $[13] = t9;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== parentClassName) {
    t13 = classNames("flex flex-col lg:hidden", parentClassName);
    $[15] = parentClassName;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw]"><PDPNameSectionPlaceholder /></div>;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Placeholder className="mb-1.5" loading={true} type="rect" style={{
      width: "100vw",
      aspectRatio: "1/1"
    }} />;
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  let t16;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className="pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw]"><PDPChooseYourOptionsPlaceholder /><PDPProtectionPlanSelectorPlaceholder /><PDPAddToBagSectionPlaceholder /></div>;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  let t17;
  if ($[20] !== t13) {
    t17 = <div className={t13} data-xc="PDPHeroShellPlaceholder-mobile">{t14}{t15}{t16}</div>;
    $[20] = t13;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  let t18;
  if ($[22] !== t12 || $[23] !== t17) {
    t18 = <>{t12}{t17}</>;
    $[22] = t12;
    $[23] = t17;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  return t18;
};
PDPHeroShellPlaceholder.propTypes = {
  className: PropTypes.string,
  isEditOrder: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool
};
export default PDPHeroShellPlaceholder;